import {createContext, ReactNode, useContext} from 'react';

export type TokenContextValue = {
    token: string | null;
};

export const TokenContext = createContext<TokenContextValue>({token: null});

export const TokenProvider = ({children, token}: { children: ReactNode; token: string | null }) => (
    <TokenContext.Provider value={{token}}>
        {children}
    </TokenContext.Provider>
);

export const useToken = () => useContext(TokenContext).token;
